import Icon from "@common/controls/Icon/component";
import { IconType, type WithChildren } from "@common/declarations";
import classNames from "classnames";
import * as React from "react";

type Props = WithChildren & {
  attributes: any;
  onDelete?: () => void;
  isSelected: boolean;
};
export default (props: Props) => {
  const [isActive, setIsActive] = React.useState(false);
  return (
    <div
      {...props.attributes}
      onDoubleClick={() => setIsActive(true)}
      className={classNames("media_container", { selected: props.isSelected, isActive })}
    >
      {props.children}

      {props.onDelete && (
        <div contentEditable="false" className="overlay">
          <div className="actions">
            <Icon icon={IconType.Delete} onClick={props.onDelete} />
          </div>
        </div>
      )}
    </div>
  );
};
